import { formatValueWithCompactNumber, formatCryptoPrice, formatPercentage } from '@/lib/format';
import { cn, genJudgingSizeColor } from '@/lib/utils';
import { ITrending } from '@/request/token/token.response.interface';
import TokenAvatar from '@/widget/TokenAvatar';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import StarNode from '@/widget/StarNode';
import BigNumber from 'bignumber.js';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useAppStore } from '@/store';

interface IProps {
  token: ITrending;
}

export default memo((props: IProps) => {
  const { token } = props;
  const { chainInfo } = useAppStore();
  const navigate = useNavigate();
  const { isConnected } = useBoomWallet();

  const onSelect = () => {
    navigate(`/${chainInfo.path}/trade/${token.address}`);
  };
  const marketCap = BigNumber(token?.totalSupply == '0' ? 1e9 : token?.totalSupply || 0)
    .times(token?.price || 0)
    .toString();

  return (
    <div className="border-b border-borderColor w-full h-[64px] flex items-center " key={token?.address}>
      <div className="flex" onClick={onSelect}>
        <div className="h-[42px] flex items-center gap-x-[8px]">
          {isConnected && <StarNode tokenAddress={token?.address} />}
          <div className="flex items-center gap-x-[8px] relative">
            <TokenAvatar logo={token?.logo} address={token?.address} className="w-[30px] h-[30px]" />
            <img src={chainInfo.icon} className="p-[1px] rounded-full bg-[#fff] w-[13px] h-[13px] absolute right-0 bottom-0" />
          </div>
          <div className="flex flex-col">
            <h3 className="text-[14px] font-[600]">{token?.symbol}</h3>
            <div className="flex text-[12px] text-secondaryTextColor">
              <span>${formatValueWithCompactNumber(token?.volume)}</span>&nbsp;·&nbsp;
              <span>${formatValueWithCompactNumber(marketCap)}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full text-right flex flex-col justify-center items-right" onClick={onSelect}>
        <p className="text-[14px]">${formatCryptoPrice(token?.price || 0)}</p>
        <p className={cn('text-[12px]', genJudgingSizeColor(token?.priceChange))}>{formatPercentage(token?.priceChange, { scale: true })}</p>
      </div>
    </div>
  );
});
